export default __webpack_public_path__ + "media/images/portfolio/gallery-03-480x580-f5f7b7fa369ecb1f4a712be5f4ee1532.jpg";